export default __webpack_public_path__ + "static/media/DeveloperAccess_domain_account_image_2.f51ce0cc.png";